module.exports = __webpack_public_path__ + "static/media/nft-2.19cdec34.png";